module.exports = __webpack_public_path__ + "img/pc-step-6.ec53ebed.jpg";